import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import {
  isTradeSoundEnabled,
  setTradeSoundEnabled,
  playTradeSound,
} from '../utils/tradeSound';
import './../Settings.css';

const Settings = () => {
  const { isDarkMode, setTheme } = useTheme();
  const navigate = useNavigate();
  const [tradeSoundOn, setTradeSoundOn] = useState(isTradeSoundEnabled);

  const handleThemeChange = (theme) => {
    setTheme(theme);
  };

  const handleTradeSoundToggle = () => {
    const next = !tradeSoundOn;
    setTradeSoundOn(next);
    setTradeSoundEnabled(next);
    if (next) {
      playTradeSound('buy');
    }
  };

  return (
    <div className={`setting-page ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
      <div className="setting-section">
        <div className="setting-section-label">Appearance</div>
        <div className="setting-card">
          <div className="setting-row setting-row-static">
            <div className="setting-row-copy">
              <div className="setting-row-title">Theme</div>
              <div className="setting-row-subtitle">Choose Light Mode or Dark Mode</div>
            </div>
          </div>
          <div className="setting-theme-toggle">
            <button
              type="button"
              className={`setting-theme-btn ${!isDarkMode ? 'active' : ''}`}
              onClick={() => handleThemeChange('light')}
            >
              Light Mode
            </button>
            <button
              type="button"
              className={`setting-theme-btn ${isDarkMode ? 'active' : ''}`}
              onClick={() => handleThemeChange('dark')}
            >
              Dark Mode
            </button>
          </div>
        </div>
      </div>

      <div className="setting-section">
        <div className="setting-section-label">Trading</div>
        <div className="setting-card">
          <button type="button" className="setting-row" onClick={handleTradeSoundToggle}>
            <div className="setting-row-copy">
              <div className="setting-row-title">Trade Sound</div>
              <div className="setting-row-subtitle">Play sound on Buy / Sell</div>
            </div>
            <span className={`setting-switch ${tradeSoundOn ? 'on' : ''}`} aria-hidden="true">
              <span className="setting-switch-knob" />
            </span>
          </button>
        </div>
      </div>

      <div className="setting-section">
        <div className="setting-section-label">Account</div>
        <div className="setting-card">
          <button
            type="button"
            className="setting-row"
            onClick={() => navigate('/change-password')}
          >
            <div className="setting-row-copy">
              <div className="setting-row-title">Change Password</div>
              <div className="setting-row-subtitle">Update your account password</div>
            </div>
            <span className="setting-chevron">›</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
